module.exports = __webpack_public_path__ + "static/media/005-happy-1.c2a745fd.svg";